import login from './login'

let loginModel = function (params) {
  let _this = this,
    { fieldName, baseUrl } = params

  new login({
    fieldName,
    baseUrl,
    success: ($login) => {
      // 这里不管同步异步，确保立马能得到YR.loginController
      _this.loginController = $login
      params.success()
    },
    error: ($login, error) => {
      _this.loginController = $login
      params.error(error)
    }
  })


  loginModel = function () {
    console.warn('全局只能调用一次loginModel方法')
  }
}

export default loginModel